import React from "react";
import { IoArrowBack } from "react-icons/io5";
import { IoTimerOutline } from "react-icons/io5";
import { IoMenu } from "react-icons/io5";
import { IoMdMore } from "react-icons/io";

import { IoCalendar } from "react-icons/io5";

import { IoFunnel } from "react-icons/io5";

import { IoNotifications } from "react-icons/io5";

import logo from "./monitor.png";

import "./AxiomAppBar.scss";
import { AxiomAppContext } from "__AxiomComponents/AxiomLayout/AxiomAppContext";

export default class AxiomAppBar extends React.Component {
  static contextType = AxiomAppContext;
  constructor(props) {
    super(props);
    this.state = {
      isRightMenuOpen: false,
    };
  }

  onHistory = () => {
    AxiomAPIs.startHistoryMode();
  };

  toggleMenu = () => {
    this.setState({ isRightMenuOpen: !this.state.isRightMenuOpen });
  };

  render() {
    let styles = {
      axiomIcons: {
        color: this.context.axiomTheme.iconsColor,
      },
      axiomSize: {
        iconSize: 25,
      },
    };

    const { axiomTheme } = this.context;

    return (
      <div className="axiom-navbar" style={{ background: axiomTheme.appbarColor }}>
        <div className="axiom-navbar-left">
          <button
            onClick={this.props.onMenuClick}
            className="axiom-navbar-action axiom-navbar-menu"
          >
            {this.props.showPrevious ? (
              <IoArrowBack size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
            ) : (
              <IoMenu size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
            )}
          </button>
          <img
            className="axiom-navbar-logo"
            src={
              this.props.appLogo && this.props.appLogo != ""
                ? this.props.appLogo
                : this.props.projectLogo && this.props.projectLogo != ""
                  ? this.props.projectLogo
                  : logo
            }
            style={{ height: this.props.appLogoHeight }}
            alt="Logo"
          />
        </div>
        <div className="axiom-navbar-title">
          {this.props.image && this.props.image.includes("AppImages") ? (
            <img src={this.props.image} style={this.props.image.includes("AppImages/queryBuilderIcon") ? { width: "16%", height: "53px" } : { width: "11%" }} alt="App Image" />
          ) : this.props.title && <span>{this.props.title}</span>}
        </div>
        {(this.props.filterIcon ||
          this.props.calendarIcon ||
          this.props.historyIcon ||
          this.props.notificationIcon) && (
            <button onClick={this.toggleMenu} className="axiom-navbar-action axiom-navbar-toggle">
              <IoMdMore size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
            </button>
          )}
        <div className={"axiom-navbar-right " + (this.state.isRightMenuOpen ? "is-open" : "")}>
          {this.props.filterIcon && (
            <button onClick={this.props.openFilterPanel} className="axiom-navbar-action">
              <IoFunnel size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
              <span className="axiom-navbar-label">Filters</span>
            </button>
          )}
          {this.props.calendarIcon && (
            <button onClick={this.props.onCalendar} className="axiom-navbar-action">
              <IoCalendar size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
              <span className="axiom-navbar-label">Select Date</span>
            </button>
          )}
          {this.props.historyIcon && (
            <button onClick={this.onHistory} className="axiom-navbar-action">
              <IoTimerOutline size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
              <span className="axiom-navbar-label">History Mode</span>
            </button>
          )}
          {this.props.notificationIcon && (
            <button className="axiom-navbar-action">
              <IoNotifications size={styles.axiomSize.iconSize} style={styles.axiomIcons} />
              {this.props.notificationCount && this.props.notificationCount > 0 ? (
                <span className="axiom-navbar-badge">{this.props.notificationCount}</span>
              ) : null}
              <span className="axiom-navbar-label">Notifications</span>
            </button>
          )}
        </div>
      </div>
    );
  }
}
